import { TextItem } from 'react-pdf';

export enum PdfActionTypes {
    SET_PDF_TEXT = 'SET_PDF_TEXT',
    SET_PDF_SEARCH_TERM = 'SET_PDF_SEARCH_TERM',
    SET_CURRENT_PDF_PAGE = 'SET_CURRENT_PDF_PAGE',
    SET_PDF_SEARCH_RESULTS = 'SET_PDF_SEARCH_RESULTS',
    SET_SELECTED_SEARCH_RESULT = 'SET_SELECTED_SEARCH_RESULT',
    CLEAR_PDF_SEARCH_TERM = 'CLEAR_PDF_SEARCH_TERM',
    CANCEL_SEARCH_SETTINGS = 'CANCEL_SEARCH_SETTINGS',
    UPDATE_SEARCH_SETTINGS = 'UPDATE_SEARCH_SETTINGS',
    SET_SCHEDULE_START_PAGE = 'SET_SCHEDULE_START_PAGE',
    APPLY_SEARCH_SETTINGS = 'APPLY_SEARCH_SETTINGS',
    RESET_PDF_SEARCH = 'RESET_PDF_SEARCH',
    RESET_PDF_TEXT = 'RESET_PDF_TEXT',
    SET_SCROLL_TO_INITIAL_RESULT = 'SET_SCROLL_TO_INITIAL_RESULT',
    SET_CONTROL_BAR_VIEW = 'SET_CONTROL_BAR_VIEW',
    SET_PDF_NUMBER_OF_PAGES = 'SET_PDF_NUMBER_OF_PAGES',
    SET_INDEXES_TO_HIGHLIGHT = 'SET_INDEXES_TO_HIGHLIGHT',
    SET_IS_CHECKING_HIGHLIGHT_INDEXES = 'SET_IS_CHECKING_HIGHLIGHT_INDEXES',
    SET_DOCUMENT_VIEWER_TYPE = 'SET_DOCUMENT_VIEWER_TYPE'
}

export interface PDFPageHighlights {
    page: number;
    highlightIndexes: number[];
    isFuzzyMatchHighlight?: boolean;
}

export enum PDFSearchType {
    EXACT = 0,
    FUZZY_2 = 0.25,
    FUZZY_3 = 0.35,
    FUZZY_4 = 0.45,
    FUZZY_5 = 0.55
}

export enum ControlBarView {
    SEARCH = 'Document Search',
    SUPPORT_DOCUMENTS = 'Support Document Select'
}

export enum DocumentViewerType {
    INCOMPLETE_DOCUMENT = 'incomplete document',
    DOCUMENT_ANALYSIS = 'document analysis',
    INCOMPLETE_OPINION = 'incomplete opinion',
    OPINION_ANALYSIS = 'opinion analysis',
    AI_DOCUMENT_ANALYSIS = 'ai document analysis',
    DORA_SUPPLY_CHAIN = 'dora supply chain preview',
    DORA_ANALYSIS = 'dora analysis',
    NETTING_ANALYSIS = 'netting analysis',
    OPINION_SUMMARY_PREVIEW = 'opinion summary preview',
    DOCUMENT_SEARCH_PREVIEW = 'document search preview',
    FEW_SHOT_DOCUMENT = 'few shot document'
}

export interface PdfPageText {
    pageNumber: number;
    textItems: TextItem[];
    searchHighlightIndexes?: number[][];
}

export interface PdfSearchResults {
    page: number;
    indexes: number[];
}

export interface PdfSearchSettings {
    searchType: PDFSearchType;
    scheduleOnly: boolean;
}

export interface PdfState {
    pdfText: PdfPageText[];
    numberOfPages: number | null;
    pdfSearchTerm: string;
    currentPdfPage: number;
    searchResults: PdfSearchResults[];
    selectedSearchResult: PdfSearchResults | null;
    searchSettings: PdfSearchSettings;
    savedSearchSettings: PdfSearchSettings;
    scheduleStartPage: number;
    scrollToInitialResult: boolean;
    controlBarView: ControlBarView;
    pageHighlightInfo: PDFPageHighlights | undefined;
    checkingPageHighlights: boolean;
    type: DocumentViewerType | null;
}
